import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';

export const Preview = styled.div`
    -ms-word-break: break-all;
    overflow-wrap: break-word;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
    border-style: solid;
    border-radius: 3px;
    border-width: 1px;
    border-color: ${theme.lightGrey};
    margin-top: 24px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
`;

export const PaneWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;

    @media (max-width: 800px) {
        flex-direction: column;
    }
`;

export const Pane = styled.div`
    width: 42%;
    padding: 8px;
    display: flex;
    flex-direction: column;

    @media (max-width: 800px) {
        width: auto;
    }
`;

export const PreviewPane = styled.div`
    width: 58%;
    padding: 8px;
    display: flex;
    flex-direction: column;

    @media (max-width: 800px) {
        width: auto;
    }
`;

export const ItemContainer = styled.div`
    margin-bottom: 12px;
`;

export const PreviewComponent = styled.span`
    background-color: rgba(255, 228, 35, 0.61);
    padding: 1px 4px;
    border-radius: 2px;
`;

export const ShortcutList = styled.ul`
    margin: 0;
    padding: 0;
`;

export const ShortcutItem = styled.li`
    display: inline;
    margin: 0 4px;
`;

export const templateStyles = {
    shortcutContainer: { marginBottom: 8 },
    textArea: { height: '100%', resize: 'vertical' },
    letterCountContainer: {
        width: '100%',
        justifyContent: 'end',
        marginTop: 8
    },
    letterCountInfo: {
        marginLeft: 4,
        alignSelf: 'flex-end',
        color: theme.primary,
        fontWeight: 'bold'
    },
    letterCount: { marginLeft: 16, marginRight: 4, alignSelf: 'flex-end' }
};

export const letterCountWarningIconStyle = css`
    margin-top: 4px;
    color: ${theme.primary};
    font-size: 0.65rem;
`;

export default {
    infoIconContainer: {
        display: 'inline-block'
    },
    infoIcon: {
        marginLeft: '5px'
    },
    enabledToggle: { margin: '0 16px' },
    sendWhenLabel: { marginRight: 8 }
};
